import { Helmet } from "react-helmet"

import Layout from "../components/layout/Layout"
import About1 from "../components/sections/About1"
import Brand1 from "../components/sections/Brand1"
import Contact from "../components/sections/Contact"
import CtaBanner from "../components/sections/CtaBanner"
import Faq from "../components/sections/Faq"
import Hero1 from "../components/sections/Hero1"
import News1 from "../components/sections/News1"
import OurSkills from "../components/sections/OurSkills"
import Project1 from "../components/sections/Project1"
import Service1 from "../components/sections/Service1"
import Team1 from "../components/sections/Team1"
import Testimonial1 from "../components/sections/Testimonial1"

export default function Home() {
	return (
		<>
			<Helmet>
				<title>V-Make | Premium WPC Doors & Frames</title>
				<meta
					name="description"
					content="Discover V-Make's durable, eco-friendly WPC doors, frames, and panels. Ideal for modern interiors and architectural needs."
				/>
				<meta property="og:type" content="website" />
				<meta property="og:updated_time" content="2024-12-02T00:00:00+00:00" />
				<meta property="article:modified_time" content="2024-12-02T00:00:00+00:00" />
				<link rel="canonical" href="https://vmakewpc.com/" />
				<script async src="https://www.googletagmanager.com/gtag/js?id=G-KVEJG711ZB" />
				<script dangerouslySetInnerHTML={{
					__html: `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-KVEJG711ZB');
  `
				}} />
			</Helmet>

			<Layout headerStyle={1} footerStyle={1}>
				<Hero1 />
				<About1 />
				<Service1 />
				<CtaBanner />
				{/* <OurSkills /> */}
				<Project1 />
				<Testimonial1 />
				<Faq />
				<div style={{ marginTop: "4rem" }} />
				{/* <Team1 /> */}
				<Contact />
				<News1 />
				{/* <Brand1 /> */}
			</Layout>
		</>
	)
}
